import * as React from 'react'
import styled from 'styled-components'
import { OptImg } from 'utils/imageOptimization'
import Link from 'theme/atoms/Link'
import useLazyImgSrc from 'hooks/useLazyImgSrc'
import theme from 'theme'
import { ReactComponent as ArrowRightSvg } from 'assets/arrow-button-right.svg'

type Props = {
  optImg: OptImg
  label: string
  link: string
}

export default function CatImage(props: Props) {
  const [ref, src] = useLazyImgSrc<HTMLImageElement>(props.optImg, 100)
  return (
    <Wrapper
      className="CatImage"
      to={props.link}
      tabIndex={0}
      aria-label={props.label}
    >
      <img src={src} ref={ref} alt="" aria-hidden="true" />
      <span className="ImageLabel" aria-hidden="true">
        {props.label}
      </span>
      <div className="arrow">
        <ArrowRightSvg />
      </div>
    </Wrapper>
  )
}

const Wrapper = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 0.0625rem solid ${theme.colors.shade.b2}; /* dunkler für Barrierefreiheit */
  @media (min-width: ${theme.ms.SM}px) {
    flex-direction: column;
    border-bottom: none;
  }

  > img {
    width: 3.75rem;
    margin-left: ${theme.spacing('m')};
    margin-right: ${theme.spacing('m')};
    margin-top: ${theme.spacing('xs')};
    margin-bottom: ${theme.spacing('xs')};
    @media (min-width: ${theme.ms.SM}px) {
      width: 9.375rem;
      height: auto;
      object-fit: contain;
    }
  }
  > .ImageLabel {
    color: ${theme.colors.b0};
    ${theme.ty('r-s')}
    text-align: center;
    display: block;
    @media (min-width: ${theme.ms.SM}px) {
      ${theme.ty('r-base')}
    }
  }

  > .arrow {
    display: block;
    margin-left: auto;
    margin-right: ${theme.spacing('m')};
    margin-bottom: inherit;
    @media (min-width: ${theme.ms.SM}px) {
      display: none;
    }
  }
`
